export function removeNestedRecord(record) {
  const recordPersisted = record.hasOwnProperty('id')

  if (recordPersisted) {
    return { ...record, _destroy: 1 }
  } else {
    return null
  }
}